import React from 'react';
import { psychologistInfo } from '../data/mock';

const privacySections = [
  {
    title: '1. Сбор персональных данных',
    intro: 'Сайт может собирать следующие данные:',
    items: [
      'имя',
      'адрес электронной почты',
      'номер телефона (если указан)',
      'информацию, которую пользователь добровольно указывает в форме обратной связи'
    ],
    outro: 'Эти данные предоставляются пользователем добровольно при заполнении контактной формы на сайте.'
  },
  {
    title: '2. Автоматически собираемая информация',
    intro: 'При посещении сайта автоматически может собираться техническая информация, включая:',
    items: [
      'IP-адрес',
      'тип браузера',
      'тип устройства',
      'страницы сайта, которые посещает пользователь',
      'время и продолжительность посещения'
    ],
    outro: 'Эти данные используются исключительно для анализа работы сайта и улучшения пользовательского опыта.'
  },
  {
    title: '3. Использование аналитических сервисов',
    paragraphs: [
      'Сайт использует сервис аналитики Google Analytics, предоставляемый компанией Google LLC, для анализа посещаемости сайта и поведения пользователей.',
      'Также используется Google Tag Manager, который помогает управлять аналитическими и маркетинговыми тегами.',
      'Данные, собираемые этими сервисами, могут включать:'
    ],
    items: [
      'IP-адрес',
      'данные о браузере',
      'информацию о взаимодействии с сайтом'
    ],
    outro: 'Эта информация используется исключительно для аналитических целей.'
  },
  {
    title: '4. Использование персональных данных',
    intro: 'Собранные данные могут использоваться для следующих целей:',
    items: [
      'ответ на запросы, отправленные через контактную форму',
      'связь с пользователем по его запросу',
      'улучшение работы сайта',
      'анализ посещаемости сайта'
    ],
    outro: 'Персональные данные не продаются и не передаются третьим лицам, за исключением случаев, предусмотренных законодательством.'
  },
  {
    title: '5. Хранение и защита данных',
    paragraphs: [
      'Администрация сайта принимает разумные технические и организационные меры для защиты персональных данных пользователей от несанкционированного доступа, изменения, раскрытия или уничтожения.'
    ]
  },
  {
    title: '6. Ссылки на сторонние сайты',
    paragraphs: [
      'Сайт может содержать ссылки на сторонние ресурсы. Администрация сайта не несёт ответственности за содержание и политику конфиденциальности таких сайтов.'
    ]
  },
  {
    title: '7. Изменения политики конфиденциальности',
    paragraphs: [
      'Администрация сайта оставляет за собой право вносить изменения в настоящую Политику конфиденциальности. Обновлённая версия политики публикуется на данной странице.'
    ]
  }
];

const PrivacyPolicyPage = () => {
  return (
    <div>
      <section className="bg-teal-700 py-16 md:py-20">
        <div className="container mx-auto px-6">
          <div className="text-center text-white">
            <p className="mb-2 text-xs font-medium uppercase tracking-[0.3em] text-sand-200">
              Документы
            </p>
            <h1 className="text-4xl font-serif md:text-5xl">
              Политика конфиденциальности
            </h1>
            <p className="mx-auto mt-4 max-w-3xl text-sand-100">
              Информация о сборе, использовании и защите персональных данных пользователей сайта
              {' '}
              dririnalazareva.com
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl space-y-8">
            <div>
              <p className="mb-3 text-sm font-medium uppercase tracking-wide text-teal-600">
                О документе
              </p>
              <h2 className="max-w-5xl text-3xl font-serif leading-tight text-stone-800 md:text-4xl">
                Ознакомьтесь с тем, как сайт обрабатывает данные и для каких целей они используются
              </h2>
            </div>

            <div className="max-w-5xl space-y-6 text-lg leading-relaxed text-stone-600">
              <p>
                Настоящая Политика конфиденциальности описывает, каким образом сайт
                {' '}
                <span className="font-medium text-stone-800">dririnalazareva.com</span>
                {' '}
                собирает, использует и защищает персональные данные пользователей.
              </p>
              <p>
                Используя данный сайт, вы соглашаетесь с условиями настоящей Политики конфиденциальности.
              </p>
            </div>

            <div className="max-w-5xl space-y-10 pt-4">
              {privacySections.map((section) => (
                <section key={section.title} className="space-y-4">
                  <h3 className="text-2xl font-serif text-stone-800">
                    {section.title}
                  </h3>

                  {section.intro ? (
                    <p className="text-lg leading-relaxed text-stone-600">
                      {section.intro}
                    </p>
                  ) : null}

                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="text-lg leading-relaxed text-stone-600">
                      {paragraph}
                    </p>
                  ))}

                  {section.items?.length ? (
                    <ul className="space-y-3 pl-6 text-lg leading-relaxed text-stone-600 list-disc marker:text-teal-600">
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : null}

                  {section.outro ? (
                    <p className="text-lg leading-relaxed text-stone-600">
                      {section.outro}
                    </p>
                  ) : null}
                </section>
              ))}

              <section className="space-y-4">
                <h3 className="text-2xl font-serif text-stone-800">
                  8. Контактная информация
                </h3>
                <p className="text-lg leading-relaxed text-stone-600">
                  Если у вас есть вопросы относительно настоящей Политики конфиденциальности,
                  вы можете связаться с администрацией сайта:
                </p>
                <div className="space-y-2 text-lg leading-relaxed text-stone-600">
                  <p>
                    Email:
                    {' '}
                    <a
                      href={`mailto:${psychologistInfo.email}`}
                      className="text-teal-600 transition-colors hover:text-teal-700"
                    >
                      {psychologistInfo.email}
                    </a>
                  </p>
                  <p>
                    Website:
                    {' '}
                    <span className="font-medium text-stone-800">dririnalazareva.com</span>
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
